<template>
  <section class="hero is-medium is-primary is-bold">
    <div class="hero-body">
      <div class="container home-mesage">
        <div class="promo_msg">
          Kinetica s-a deschis in toamna anului 2011, cu scopul de prevenire și tratament al tuturor
          deficiențelor aparatului locomotor
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Hero"
};
</script>

<style scoped>
.hero.is-primary.is-bold {
  background-size: cover;
  background-position: center;
  height: 550px;
  background-position-y: -40px;
  background-repeat: no-repeat;
  background-image: url("../assets/JOC_3757.webp");
}
.promo_msg {
  background: #ffffffc0;
  border-radius: 0.5rem;
  font-size: 26px;
  margin: 0.5rem 0;
  padding: 0.5rem;
  color: black;
}
.home-mesage {
  margin: 0 auto;
  max-width: 800px;
  position: relative;
  padding-top: 280px;
}
.hero.is-primary {
  background-color: white;
}
</style>
